define('responsive-gameday/views/distributors/viewDistributors/BoxscoreDistributor',['require','exports','module','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','jquery'],function(require,exports,module) {
	var ViewDistributorClass = require("./ViewDistributorBase"),
		UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
		MessageService = require("message-service/message-service"),
		DistEvents = require("../events/DistributionEvents"),
		exists = require("extant/extant"),
		$ = require('jquery');

	var Superclass;

	function BoxscoreDistributor(evt) {
        Superclass.constructor.call(this,evt);
		this.eventType = evt;
        
		MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
		MessageService.addListener.call(this, UpdateEvents.REQUEST_BOX_DATA, this.handleUpdateRequest);
	}

	ViewDistributorClass.spawn(BoxscoreDistributor).define({
		prepDataForView: function() {
			this.dataPack = { };
			var innState = this.game.liveData.linescore.inningState,
				that = this;
			if (exists(this.game, "gameData")) {
				var box = this.game.liveData.boxscore;
				this.dataPack.linescore = this.game.liveData.linescore;
				this.dataPack.teams = {
					home: this.game.gameData.teams.home,
					away: this.game.gameData.teams.away
				};
				this.dataPack.gameInfo = box.gameInfo;
				this.dataPack.lineups = {
					home: $.extend({},this.game.liveData.players.home, box.teams.home),
					away: $.extend({},this.game.liveData.players.away, box.teams.away)
				};

				this.dataPack.isActive = function () {
					return this.status.isCurrentBatter ? 'class="active"' : '';
				};

				this.dataPack.isHomeBatting = (innState === 'Top' || innState === 'End') ? false : true;

				this.dispatchUpdates(this.eventType, this.dataPack);
			};

			this.dispatchUpdates();
		}
	});

	Superclass = BoxscoreDistributor.superclass;

	return BoxscoreDistributor;
});
